import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { AvailableWithdrawValue } from "../../Api/Panel/AvailableWithdrawValue";
import { GetUserwithdraw } from "../../Api/Panel/GetUserwithdraw";
import { useAuth } from "../../Context/AuthContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { RequestWithdraw } from "../../Api/Panel/RequestWithdraw";
import Swal from "sweetalert2";

export default function Withdrawpage() {
  const [widthDraw, setWidthDraw] = useState([]);
  const [availableValue, setAvailableValue] = useState(0);
  const { userID } = useAuth();

  const GET = async () => {
    const { data } = await GetUserwithdraw(userID);
    setWidthDraw(data);
    const { data: available } = await AvailableWithdrawValue(userID);
    setAvailableValue(available);
  };

  useEffect(() => {
    GET();
    //eslint-disable-next-line
  }, []);

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } =
    useFormik({
      initialValues: {
        Value: "",
        TxAddress: "",
      },
      validationSchema: Yup.object({
        Value: Yup.number().min(1).required("Value required!"),
        TxAddress: Yup.string()
          .min(10, "Should be min 10 character")
          .required("Transaction Address required!"),
      }),
      onSubmit: async (values) => {
        console.log(values);
        const gidecekData = {
          ...values,
          userID,
        };
        const { data } = await RequestWithdraw(gidecekData);
        if (data.status === true) {
          Swal.fire("Withdraw Successful!", `${data.msg}`, "success");
          GET();
        } else {
          Swal.fire("Withdraw Failed!", `${data.msg}`, "error");
        }
      },
    });

  return (
    <>
      <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full">
          <h2 className="text-xl lg:text-2xl text-center pb-6 w-full black-color">
            List of your Withdraw
          </h2>

          <div className="overflow-x-auto relative">
            <table className="w-full mb-10 text-sm text-left text-gray-400">
              <thead className="text-xs uppercase bg-gray-200 text-gray-800">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Date
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Sent Value
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Receiver Address
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {widthDraw.map((el, i) => {
                  let date = new Date(el?.TxDate * 1);
                  date =
                    date.getFullYear() +
                    "/" +
                    (date.getMonth() + 1) +
                    "/" +
                    +date.getDate() +
                    " " +
                    date.getHours() +
                    ":" +
                    date.getMinutes() +
                    ":" +
                    date.getSeconds();
                  return (
                    <tr key={i} className=" bg-gray-100 border-gray-700">
                      <th
                        scope="row"
                        className="py-4 px-6 font-normal whitespace-nowrap text-gray-800"
                      >
                        {date}
                      </th>
                      <td className="py-4 px-6 text-gray-800">{el.Value}</td>
                      <td className="py-4 px-6 text-gray-800">
                        {el.TxAddress}
                      </td>
                      <td
                        className={`py-4 px-6 ${
                          el.Status === "Pending"
                            ? "text-orange-500"
                            : el.Status === "Confirm"
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      >
                        {el.Status}
                      </td>
                    </tr>
                  );
                })}

                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-normal whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2 rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-52"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-52"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-52"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-52"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className=" bg-gray-100 border-gray-700">
                  <th
                    scope="row"
                    className="py-4 px-6 font-medium whitespace-nowrap text-gray-800"
                  >
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </th>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-gray-800">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-52"></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-red-500">
                    <div
                      role="status"
                      className="space-y-2.5 animate-pulse max-w-lg"
                    >
                      <div className="flex items-center space-x-2 w-full">
                        <div className="h-2  rounded-full bg-gray-700 w-32"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="bg-gray-50 px-4 py-5 sm:px-6">
            <dt className="text-sm mb-8 font-medium text-gray-500">
              Available Value to Withdraw : ${availableValue}
            </dt>

            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <dt className="text-sm font-medium text-gray-500">
                  The value You want to send
                </dt>
                <input
                  onChange={handleChange}
                  value={values.Value}
                  onBlur={handleBlur}
                  name="Value"
                  type="number"
                  className="form-control mb-10 block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Value to Withdraw"
                />
                {touched.Value && errors.Value && (
                  <span className="text-red-500 py-2">{errors.Value}</span>
                )}

                <dt className="text-sm font-medium text-gray-500">
                  Your Wallet Address
                </dt>
                <input
                  onChange={handleChange}
                  value={values.TxAddress}
                  onBlur={handleBlur}
                  name="TxAddress"
                  type="text"
                  className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Your Wallet Address"
                />
                {touched.TxAddress && errors.TxAddress && (
                  <span className="text-red-500 py-2">{errors.TxAddress}</span>
                )}

                <div className="px-4 py-5">
                  <p className="text-sm text-gray-900 text-center lg:text-md">
                    After sending the request to withdraw
                    <br />
                    We checking and reviewing, your withdraw request will be
                    transfer within 30 minutes.
                  </p>
                </div>
                <div className="flex w-full">
                  <button
                    type="submit"
                    className=" mx-auto w-full lg:w-[20%] cursor-pointer text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-[#3742fa] p-2bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                  >
                    request to withdraw
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
